import { Translate } from '../../../../shared/LanguageService';
import { CreateEditingStyleFailure } from './useCreateEditingStyle';

export function createErrorText(createError: CreateEditingStyleFailure | null): string {
    if (createError === null) {
        return '';
    }

    if (createError.messages.length > 0) {
        return createError.messages.map((message) => Translate(message.key)).join(' ');
    }

    return Translate('editing-styles/notification/create-failed', { name: createError.name });
}
